var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-tooltip',{attrs:{"top":"","disabled":!_vm.truncated},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({ref:"textTruncateBlock",staticClass:"truncate",style:(_vm.style)},on),[_vm._v(" "+_vm._s(_vm.text)+" ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }